import {computed} from "vue";
import dayjs from "dayjs";

export function useDates() {
    const currentYear = computed(() => {
        return dayjs().format("YYYY");
    });

    return {
        currentYear
    };
}
